import React, { useState } from 'react'
import clientData from 'utils/client-data'
import glamorous from 'glamorous'
import { get } from 'lodash'
import { css } from 'glamor'
import {
  HeadingText,
  BodyText,
  Button,
  Link,
  v2grey600,
} from '@paypalcorp/pp-react'
import getContent from 'pp-react-l10n'
import ShareProfilePopup from '../shared/components/share-profile-popup'
const l10n = getContent('pages/seller/success')

const Container = glamorous.div({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  margin: '10px',
  '@media(max-width: 414px)': {
    margin: 0,
  },
})

const Heading = css({
  marginTop: 180,
  textAlign: 'center',
  width: '100%',
  '@media(max-width: 414px)': {
    marginTop: 120,
    width: '90%',
  },
  '@media(max-width: 374px)': {
    marginTop: 60,
  },
  '@media(max-width: 325px)': {
    marginTop: 10,
  },
})

const SubHeading = css({
  marginTop: 16,
  width: 380,
  color: v2grey600,
  textAlign: 'center',
  '@media(max-width: 414px)': {
    width: 274,
  },
})

const DoneBtn = css({
  textAlign: 'center',
  width: 300,
  marginTop: 200,
  '@media(max-width: 414px)': {
    marginTop: 140,
    width: 280,
  },
  '@media(max-width: 374px)': {
    marginTop: 100,
    width: 265,
  },
  '@media(max-width: 325px)': {
    marginTop: 60,
    width: 250,
  },
})

const ShareLink = css({
  marginTop: 40,
  '@media(max-width: 414px)': {
    marginTop: 24,
  },
})

function Success(props) {
  const {
    history: {
      location: { state: { businessName = '', businessHandle = '' } = {} } = {},
    } = {},
  } = props
  const [displaySharePopup, setdisplaySharePopup] = useState(false)

  const redirectToDashboard = () => {
    props.history.push(`/seller/${businessHandle}/dashboard`)
  }

  const shareLink = `https://paypal.me/${businessHandle}?locale.x=${get(
    clientData,
    'locality.locale',
  )}`

  return (
    <Container>
      <HeadingText
        size="md"
        role="heading"
        aria-level="1"
        className={`${Heading}`}
      >
        {l10n('header', { business: businessName })}
      </HeadingText>
      <BodyText className={`${SubHeading}`}>{l10n('subheader')}</BodyText>
      <Button className={`${DoneBtn}`} onClick={redirectToDashboard}>
        {l10n('doneButton')}
      </Button>
      <Link
        title="Primary"
        className={`${ShareLink}`}
        onClick={() => setdisplaySharePopup(true)}
      >
        {l10n('shareYourProfile')}
      </Link>
      <ShareProfilePopup
        isOpen={displaySharePopup}
        handleDisplay={setdisplaySharePopup}
        header={l10n('popup.header')}
        mobileHeader={l10n('popup.mobileHeader')}
        subheader={l10n('popup.subheader')}
        shareLink={shareLink}
        sellerName={businessName}
      />
    </Container>
  )
}

export default Success
